
// @ts-nocheck
import locale__opt_atlassian_pipelines_agent_build_locales_en_json from "../locales/en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_auth_en_json from "../locales/auth-en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_homePage_en_json from "../locales/homePage-en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_shopPage_en_json from "../locales/shopPage-en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_cart_en_json from "../locales/cart-en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_en_json from "../locales/checkoutPage-en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_en_json from "../locales/thanksPage-en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_error_en_json from "../locales/error-en.json";
import locale__opt_atlassian_pipelines_agent_build_locales_fr_json from "../locales/fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_auth_fr_json from "../locales/auth-fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_homePage_fr_json from "../locales/homePage-fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_shopPage_fr_json from "../locales/shopPage-fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_cart_fr_json from "../locales/cart-fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_fr_json from "../locales/checkoutPage-fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_fr_json from "../locales/thanksPage-fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_error_fr_json from "../locales/error-fr.json";
import locale__opt_atlassian_pipelines_agent_build_locales_nl_json from "../locales/nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_auth_nl_json from "../locales/auth-nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_homePage_nl_json from "../locales/homePage-nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_shopPage_nl_json from "../locales/shopPage-nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_cart_nl_json from "../locales/cart-nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_nl_json from "../locales/checkoutPage-nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_nl_json from "../locales/thanksPage-nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_error_nl_json from "../locales/error-nl.json";
import locale__opt_atlassian_pipelines_agent_build_locales_de_json from "../locales/de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_auth_de_json from "../locales/auth-de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_homePage_de_json from "../locales/homePage-de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_shopPage_de_json from "../locales/shopPage-de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_cart_de_json from "../locales/cart-de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_de_json from "../locales/checkoutPage-de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_de_json from "../locales/thanksPage-de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_error_de_json from "../locales/error-de.json";
import locale__opt_atlassian_pipelines_agent_build_locales_it_json from "../locales/it.json";
import locale__opt_atlassian_pipelines_agent_build_locales_auth_it_json from "../locales/auth-it.json";
import locale__opt_atlassian_pipelines_agent_build_locales_homePage_it_json from "../locales/homePage-it.json";
import locale__opt_atlassian_pipelines_agent_build_locales_shopPage_it_json from "../locales/shopPage-it.json";
import locale__opt_atlassian_pipelines_agent_build_locales_cart_it_json from "../locales/cart-it.json";
import locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_it_json from "../locales/checkoutPage-it.json";
import locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_it_json from "../locales/thanksPage-it.json";
import locale__opt_atlassian_pipelines_agent_build_locales_error_it_json from "../locales/error-it.json";


export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "it"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_en_json), cache: true },
{ key: "../locales/auth-en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_auth_en_json), cache: true },
{ key: "../locales/homePage-en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_homePage_en_json), cache: true },
{ key: "../locales/shopPage-en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_shopPage_en_json), cache: true },
{ key: "../locales/cart-en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_cart_en_json), cache: true },
{ key: "../locales/checkoutPage-en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_en_json), cache: true },
{ key: "../locales/thanksPage-en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_en_json), cache: true },
{ key: "../locales/error-en.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_error_en_json), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_fr_json), cache: true },
{ key: "../locales/auth-fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_auth_fr_json), cache: true },
{ key: "../locales/homePage-fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_homePage_fr_json), cache: true },
{ key: "../locales/shopPage-fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_shopPage_fr_json), cache: true },
{ key: "../locales/cart-fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_cart_fr_json), cache: true },
{ key: "../locales/checkoutPage-fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_fr_json), cache: true },
{ key: "../locales/thanksPage-fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_fr_json), cache: true },
{ key: "../locales/error-fr.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_error_fr_json), cache: true }],
  "nl": [{ key: "../locales/nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_nl_json), cache: true },
{ key: "../locales/auth-nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_auth_nl_json), cache: true },
{ key: "../locales/homePage-nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_homePage_nl_json), cache: true },
{ key: "../locales/shopPage-nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_shopPage_nl_json), cache: true },
{ key: "../locales/cart-nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_cart_nl_json), cache: true },
{ key: "../locales/checkoutPage-nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_nl_json), cache: true },
{ key: "../locales/thanksPage-nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_nl_json), cache: true },
{ key: "../locales/error-nl.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_error_nl_json), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_de_json), cache: true },
{ key: "../locales/auth-de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_auth_de_json), cache: true },
{ key: "../locales/homePage-de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_homePage_de_json), cache: true },
{ key: "../locales/shopPage-de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_shopPage_de_json), cache: true },
{ key: "../locales/cart-de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_cart_de_json), cache: true },
{ key: "../locales/checkoutPage-de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_de_json), cache: true },
{ key: "../locales/thanksPage-de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_de_json), cache: true },
{ key: "../locales/error-de.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_error_de_json), cache: true }],
  "it": [{ key: "../locales/it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_it_json), cache: true },
{ key: "../locales/auth-it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_auth_it_json), cache: true },
{ key: "../locales/homePage-it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_homePage_it_json), cache: true },
{ key: "../locales/shopPage-it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_shopPage_it_json), cache: true },
{ key: "../locales/cart-it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_cart_it_json), cache: true },
{ key: "../locales/checkoutPage-it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_checkoutPage_it_json), cache: true },
{ key: "../locales/thanksPage-it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_thanksPage_it_json), cache: true },
{ key: "../locales/error-it.json", load: () => Promise.resolve(locale__opt_atlassian_pipelines_agent_build_locales_error_it_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute"
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "name": "English",
      "language": "en-US",
      "files": [
        "/opt/atlassian/pipelines/agent/build/locales/en.json",
        "/opt/atlassian/pipelines/agent/build/locales/auth-en.json",
        "/opt/atlassian/pipelines/agent/build/locales/homePage-en.json",
        "/opt/atlassian/pipelines/agent/build/locales/shopPage-en.json",
        "/opt/atlassian/pipelines/agent/build/locales/cart-en.json",
        "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-en.json",
        "/opt/atlassian/pipelines/agent/build/locales/thanksPage-en.json",
        "/opt/atlassian/pipelines/agent/build/locales/error-en.json"
      ]
    },
    {
      "code": "fr",
      "language": "fr-FR",
      "name": "French",
      "files": [
        "/opt/atlassian/pipelines/agent/build/locales/fr.json",
        "/opt/atlassian/pipelines/agent/build/locales/auth-fr.json",
        "/opt/atlassian/pipelines/agent/build/locales/homePage-fr.json",
        "/opt/atlassian/pipelines/agent/build/locales/shopPage-fr.json",
        "/opt/atlassian/pipelines/agent/build/locales/cart-fr.json",
        "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-fr.json",
        "/opt/atlassian/pipelines/agent/build/locales/thanksPage-fr.json",
        "/opt/atlassian/pipelines/agent/build/locales/error-fr.json"
      ]
    },
    {
      "code": "nl",
      "name": "Dutch",
      "language": "nl-NL",
      "files": [
        "/opt/atlassian/pipelines/agent/build/locales/nl.json",
        "/opt/atlassian/pipelines/agent/build/locales/auth-nl.json",
        "/opt/atlassian/pipelines/agent/build/locales/homePage-nl.json",
        "/opt/atlassian/pipelines/agent/build/locales/shopPage-nl.json",
        "/opt/atlassian/pipelines/agent/build/locales/cart-nl.json",
        "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-nl.json",
        "/opt/atlassian/pipelines/agent/build/locales/thanksPage-nl.json",
        "/opt/atlassian/pipelines/agent/build/locales/error-nl.json"
      ]
    },
    {
      "code": "de",
      "name": "German",
      "language": "de-DE",
      "files": [
        "/opt/atlassian/pipelines/agent/build/locales/de.json",
        "/opt/atlassian/pipelines/agent/build/locales/auth-de.json",
        "/opt/atlassian/pipelines/agent/build/locales/homePage-de.json",
        "/opt/atlassian/pipelines/agent/build/locales/shopPage-de.json",
        "/opt/atlassian/pipelines/agent/build/locales/cart-de.json",
        "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-de.json",
        "/opt/atlassian/pipelines/agent/build/locales/thanksPage-de.json",
        "/opt/atlassian/pipelines/agent/build/locales/error-de.json"
      ]
    },
    {
      "code": "it",
      "name": "Italian",
      "language": "it-IT",
      "files": [
        "/opt/atlassian/pipelines/agent/build/locales/it.json",
        "/opt/atlassian/pipelines/agent/build/locales/auth-it.json",
        "/opt/atlassian/pipelines/agent/build/locales/homePage-it.json",
        "/opt/atlassian/pipelines/agent/build/locales/shopPage-it.json",
        "/opt/atlassian/pipelines/agent/build/locales/cart-it.json",
        "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-it.json",
        "/opt/atlassian/pipelines/agent/build/locales/thanksPage-it.json",
        "/opt/atlassian/pipelines/agent/build/locales/error-it.json"
      ]
    }
  ],
  "defaultLocale": "nl",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": false,
  "langDir": "./../locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "name": "English",
    "language": "en-US",
    "files": [
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/en.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/auth-en.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/homePage-en.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/shopPage-en.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/cart-en.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-en.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/thanksPage-en.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/error-en.json"
      }
    ]
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "name": "French",
    "files": [
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/fr.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/auth-fr.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/homePage-fr.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/shopPage-fr.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/cart-fr.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-fr.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/thanksPage-fr.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/error-fr.json"
      }
    ]
  },
  {
    "code": "nl",
    "name": "Dutch",
    "language": "nl-NL",
    "files": [
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/nl.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/auth-nl.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/homePage-nl.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/shopPage-nl.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/cart-nl.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-nl.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/thanksPage-nl.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/error-nl.json"
      }
    ]
  },
  {
    "code": "de",
    "name": "German",
    "language": "de-DE",
    "files": [
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/de.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/auth-de.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/homePage-de.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/shopPage-de.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/cart-de.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-de.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/thanksPage-de.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/error-de.json"
      }
    ]
  },
  {
    "code": "it",
    "name": "Italian",
    "language": "it-IT",
    "files": [
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/it.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/auth-it.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/homePage-it.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/shopPage-it.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/cart-it.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/checkoutPage-it.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/thanksPage-it.json"
      },
      {
        "path": "/opt/atlassian/pipelines/agent/build/locales/error-it.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
